<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <!-- 세금 계산서 발행 안내 팝업 -->
    <i-dxpopup
      :popupVisible="statusGuidePopupVisible"
      :title="'발행 상태 안내'"
      @popupCloseButtonClick="statusGuidePopupVisible = false"
      :height="'550'"
      :width="'1000'"
    >
      <template v-slot:content>
        <TaxInvoiceStatusPopup />
      </template>
    </i-dxpopup>
    <!-- 세금 계산서 발행 안내 팝업 종료 -->
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="세금계산서 발행" :IsUseEditorBox="true" :IsUseInnerAddition="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <span class="d-flex align-center"> 작성일자 : </span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'start')"
                :allowMaxDate="setDateFormat(searchEndDate, '-')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                class="mx-1"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'end')"
                :allowMinDate="setDateFormat(searchStartDate, '-')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:innerAddition>
          <v-row no-gutters>
            <v-btn color="btn_thi" elevation="0" large @click="statusGuidePopupVisible = true">{{ '발행 상태 안내' }}</v-btn>
          </v-row>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="taxInvoiceManageDataGrid"
                  class="layout-col-height00"
                  style="width: 100%; height: 100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  key-expr="seq"
                >
                  <DxColumn
                    data-field="detail"
                    data-type="string"
                    width="100px"
                    alignment="center"
                    caption="상세보기"
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn color="primary" elevation="0" small @click="btnDetail(cellInfo)" class="grid-btn">상세보기</v-btn>
                    </div>
                  </template>
                  <DxColumn data-field="clntNm" data-type="string" alignment="center" width="300px" caption="고객사명" :allow-editing="false" />
                  <DxColumn data-field="taxTypeNm" data-type="string" alignment="center" width="140px" caption="종류" :allow-editing="false" />
                  <DxColumn data-field="representativeOrderId" data-type="string" alignment="center" width="260px" caption="대표 주문번호" :allow-editing="false" />
                  <DxColumn data-field="orderId" data-type="string" alignment="center" width="260px" caption="주문번호" :allow-editing="false" />
                  <DxColumn data-field="docNumber" data-type="string" alignment="center" width="260px" caption="문서번호" :allow-editing="false" />
                  <DxColumn
                    data-field="orgIssueId"
                    data-type="string"
                    alignment="center"
                    width="260px"
                    caption="대상 문서번호"
                    :allow-editing="false"
                    cell-template="CVATypeTemplate"
                  />
                  <template #CVATypeTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.value">{{ cellInfo.value }}</div>
                    <div v-else>{{ '-' }}</div>
                  </template>
                  <DxColumn data-field="statusNm" data-type="string" alignment="center" width="200px" caption="발행 상태" :allow-editing="false" />
                  <DxColumn data-field="errMsgNm" data-type="string" alignment="left" width="200px" caption="에러 메시지" :allow-editing="false" cell-template="errorMessageTemplate"/>
                  <template #errorMessageTemplate="{ data: cellInfo }">
                    <div
                      :style="{
                        width: '100%',
                        textAlign: cellInfo.value === '-' ? 'center' : 'left'
                      }"
                    >
                      {{ cellInfo.value }}
                    </div>
                  </template>
                  <DxColumn
                    data-field="genTm"
                    data-type="date"
                    alignment="center"
                    format="yyyy.MM.dd"
                    width="150px"
                    caption="작성일자"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="dlvTmFormat"
                    data-type="date"
                    alignment="center"
                    format="yyyy.MM.dd"
                    width="150px"
                    caption="전달일자"
                    :allow-editing="false"
                  />
                  <DxColumn
                    data-field="taxSupprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="공급가액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <DxColumn
                    data-field="taxTaxprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="세액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <DxColumn
                    data-field="payTotalprice"
                    data-type="number"
                    alignment="right"
                    width="150px"
                    caption="합계금액"
                    :allow-editing="false"
                    cell-template="amountCellTemplate"
                  />
                  <template #amountCellTemplate="{ data: cellInfo }">
                    <div v-if="cellInfo.value === '-'">{{ '-' }}</div>
                    <div v-else>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
                  </template>
                  <DxColumn data-field="itemBigo" data-type="string" alignment="center" width="240px" caption="비고" :allow-editing="false" />
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right
        headerTitle
        :useBtnList="buttonUseList"
        :reportItems="reportItems"
        @btnSearch="btnSearch(true)"
        @btnAdd="btnAdd()"
        @btnDelete="btnDelete()"
        @btnPrint="btnPrint"
      >
        <template v-slot:body>
          <v-layout>
            <v-row no-gutters class="pa-0 pt-2">
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </v-layout>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import { getCommonCode } from '@/api/common/commonApi'
import { getClientPaymentHistoryList } from '@/payment/api/clientPaymentHistory'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'

import iDxPopup from '@/components/common/iDxPopup.vue'
import TaxInvoiceStatusPopup from '@/views/adminManagement/TaxInvoiceStatusPopup.vue'

import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'

// api
import {
  getTaxInvoiceManage, //세금계산서 조회
  deleteTaxInvoice, // 세금계산서 삭제
  IssuanceTaxInvoice, // 세금계산서 보류 및 발행
} from '@/payment/api/taxInvoice.js'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'taxInvoiceManage',
  components: {
    IDateTimePicker,
    'i-dxpopup': iDxPopup,
    TaxInvoiceStatusPopup,
  },
  data() {
    return {
      dxDataGridRef: 'taxInvoiceManage',
      buttonUseList: [
        'btnSearch', // 조회
        'btnAdd', // 추가
        'btnDelete', // 삭제
        'btnPrint', // 출력
      ],
      reportItems: [{ role: 'xls', title: 'EXCEL' }],
      gridMain: [],
      startDate: getPreMonth(12),
      endDate: getPreMonth(0),
      searchStartDate: getPreMonth(12).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),
      searchMinDate: getCurrentDate(),
      searchMaxDate: getPreMonth(12),
      minDate: getCurrentDate(),
      statusGuidePopupVisible: false, // 발행상태 안내 팝업 가시화 여부
    }
  },
  computed: {},
  beforeMount() {},
  activated() {
    this.applySearchPeriod()
  },
  created() {},
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    // 대시보드에서 넘어올 경우 최근 2개월을 조회 기간으로 설정
    applySearchPeriod(route = this.$route) {
      const params = route.params.data || {}
      const isRecentTwoMonths =
        route.query.from === 'dashboard' &&
        route.query.period === '2months'

      let startDate = getPreMonth(isRecentTwoMonths ? 2 : 12)
      let endDate = getCurrentDate()

      // 기존 정산 페이지에서 전달한 기간 우선 적용
      if (params.flag && params.startDate && params.endDate) {
        startDate = params.startDate
        endDate = params.endDate > getCurrentDate()
          ? getCurrentDate()
          : params.endDate
      }

      this.startDate = startDate
      this.endDate = endDate
      this.searchStartDate = startDate.replace(/[^0-9]/g, '')
      this.searchEndDate = endDate.replace(/[^0-9]/g, '')

      this.btnSearch(true)
    },
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
      this.btnSearch()
    },
    setDateFormat(date, div = '.') {
      return `${date.substring(0, 4)}${div}${date.substring(4, 6)}${div}${date.substring(6, 8)}`
    },
    //------------------------------------------
    //  고객사 결제 내역 확인 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      const params = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }

      this.openLoading()

      try {
        const [res, codeRes] = await Promise.all([
          getTaxInvoiceManage(params, true),

          // 시스템코드 조회 실패 시에도 목록은 표시
          getCommonCode('TAX002').catch(() => null),
        ])

        if (!res.success) return

        const errorCodes = codeRes && codeRes.success ? codeRes.list || [] : []

        const errorCodeMap = new Map(
          errorCodes.map((code) => [
            String(code.minorCd).trim(), 
            code.minorNm,
          ])
        )

        this.gridMain = (res.list || []).map((item) => {
          const errorCode =
            item.errMsg == null ? '' : String(item.errMsg).trim()

          return {
            ...item, 
            errMsgNm: errorCode === '' ?  '-': errorCodeMap.get(errorCode) || `-`,
          }
        })
      } catch (error) {
        console.error('세금계산서 목록 조회 실패:', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  추가 클릭
    //------------------------------------------
    async btnAdd() {
      this.vToastifyPrompt(
        this.$t(`세금계산서 발행페이지로 이동하시겠습니까?`),
        'info',
        (current) => {
          const toRouter = {
            name: 'TaxInvoiceManageDetail',
            params: { data: { __created__: true } },
          }
          this.$router.push(toRouter)
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  삭제 클릭
    //------------------------------------------
    async btnDelete() {
      // status === PND -- delete
      // status === (NLW,NLE,NLF) -- 삭제 불가
      // status === 그외 - update(stauts=CCR)
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      let filteredData = selectedRows.filter((el) => el.status === 'NLW' || el.status === 'NLE' || el.status === 'NLF')
      if (filteredData.length > 0) {
        this.vToastify('발행 상태가 [국세청 응답 대기, 국세청 응답 에러, 국세청 제출 완료]인 항목은 삭제할 수 없습니다.', 'info')
        return
      }

      this.vToastifyPrompt(
        this.$t(`세금계산서를 삭제를 요청하시겠습니까? (보류 항목은 즉시 삭제됩니다.)`),
        'info',
        (current) => {
          this.openLoading()
          deleteTaxInvoice(selectedRows, true)
            .then((res) => {
              this.btnSearch()
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  상세보기 클릭
    //------------------------------------------
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'TaxInvoiceManageDetail',
        params: cellInfo,
      }
      this.$router.push(toRouter)
    },
    formatDate(date, div = '.') {
      if (!date) return null

      if (date.indexOf(div) == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      } else if (date.indexOf(div) > -1) {
        const [year, month, day] = date.split(div)
        return `${year}${div}${month}${div}${day}`
      } else {
        return date
      }
    },
    btnPrint(type) {
      if (type == 'xls') {
        const docTitle = `세금계산서 발행 내역(${this.formatDate(this.searchStartDate)}~${this.formatDate(this.searchEndDate)}).xlsx`
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('세금계산서 발행 내역')
        exportExcel({
          component: this.GetDataGrid(this.dxDataGridRef),
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), docTitle)
          })
        })
      }
    },
  },
}
</script>

<style scoped></style>
